import { Subtext } from '../../styled/components/order-item-subtext';

type SubtextProps = { text: string };

// Rendered on every order-item subtext row a customer sees while completing an offer purchase —
// both the offer wizard's own order-summary/index.tsx and Order Review's summary.tsx (via
// order-item.tsx) share this component.
const OrderItemSubtext = ({ text }: SubtextProps) => <Subtext className='text-xs'>{text}</Subtext>;

export default OrderItemSubtext;
